
import TenantContent from '@/components/elements/TenantContent'
import LoginForm from '@/components/forms/LoginForm.vue'
import { indexItemsById } from '@/helpers/IndexHelpers'
import { changeMemberDetailsInstructions } from '@/helpers/LanguageHelpers'
import { memberHasNoEmailAddress } from '@/helpers/RequireMemberEmailAddress'
import { isLoggedIn } from '@/state/Authentication'
import { isCurrentMember } from '@/state/Membership'
import store from '@/store/store'
import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { LanguageStrings } from '@/language/types'

@Component({
  name: 'MembershipModal',
  components: { LoginForm, TenantContent },
  computed: mapGetters({
    user: 'Member/user',
    membershipLevel: 'Member/membershipLevelName',
  }),
})
export default class extends Vue {
  t: LanguageStrings['membershipModal']

  get hasMembership(): boolean {
    return isCurrentMember()
  }

  get expiry(): string {
    const medium = this.$t('dateFormat.medium')
    return store.getters['Member/membershipExpiry'].format(medium)
  }

  get isLoggedIn(): boolean {
    return isLoggedIn()
  }

  get members(): { admitName: string; typeName: string }[] {
    const types: Dict<TicketType> = indexItemsById(store.getters['Member/ticketTypes'])
    return (store.getters['Member/tickets'] as Ticket[])
      .filter((ticket) => ticket.admit_name.length > 0)
      .map((ticket) => ({ ticket, type: types[ticket.ticket_type_id] }))
      .sort((a, b) => a.type._rank - b.type._rank)
      .map(({ ticket, type }) => ({
        admitName: ticket.admit_name,
        typeName: type.name,
      }))
  }

  get primaryMember() {
    return this.members[0]
  }

  get secondaryMember() {
    return this.members[1]
  }

  get otherMemberNames(): string {
    return this.members
      .filter((member, index) => index > 1)
      .map((member) => member.admitName)
      .join(', ')
  }

  get emailAddress(): string {
    const user = store.getters['Member/user']
    return memberHasNoEmailAddress() ? this.t.noEmailMessage : user.email
  }

  get changeMemberDetailsInstructions(): string {
    return changeMemberDetailsInstructions()
  }

  renewClicked() {
    this.$modals.close()
    this.$router.push('/membership/renew')
  }
}
